import {JsonObject, JsonProperty} from "typescript-json-serializer";

@JsonObject()
export class SnappingOptionsPropertiesConfiguration {
    /**
     * When true, enables support for attribute rule-based snapping.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-snapping-SnappingOptions.html#attributeRulesEnabled)
     */
    @JsonProperty()
    declare attributeRulesEnabled?: boolean;
    /**
     * Snapping distance for snapping in pixels.
     *
     * @default 5
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-snapping-SnappingOptions.html#distance)
     */
    @JsonProperty()
    declare distance?: number;
    /**
     * Global configuration to turn snapping on or off.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-snapping-SnappingOptions.html#enabled)
     */
    @JsonProperty()
    declare enabled?: boolean;
    /**
     * Global configuration option to turn feature snapping on or off.
     *
     * @default true
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-snapping-SnappingOptions.html#featureEnabled)
     */
    @JsonProperty()
    declare featureEnabled?: boolean;
    /**
     * List of sources for feature snapping.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-snapping-SnappingOptions.html#featureSources)
     */
    //@JsonProperty()
    //declare featureSources?: CollectionProperties<FeatureSnappingLayerSourceProperties>;
    /**
     * Global configuration option to turn self snapping (within one feature while either drawing or reshaping) on or off.
     *
     * @default true
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-snapping-SnappingOptions.html#selfEnabled)
     */
    @JsonProperty()
    declare selfEnabled?: boolean;

    constructor() {}
}
